<template>
  <b-card>
    <FormView
      :data="$store.getters['product/detailData']"
      :fields="$store.getters['product/tableFields']"
      @load="loadData"
    />
  </b-card>
</template>

<script>
import FormView from '@/layouts/components/FormView.vue'

import {
  BCard,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    FormView,
  },
  methods: {
    loadData(id) {
      return this.$store.dispatch('product/getDetail', id)
    },
  },
}
</script>

<style scoped>

</style>
